/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Reactivated_DescInputs */



/**
* | output |
* | --- |
* | "Access was restored, taking a seat again. Everything they had before is available without reconnecting." |
*
* @param {Audit_Details_Member_Reactivated_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_reactivated_desc = /** @type {((inputs?: Audit_Details_Member_Reactivated_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Reactivated_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Zugang wurde wiederhergestellt und belegt wieder einen Platz. Alles Bisherige ist ohne erneutes Verbinden verfügbar.")
	return /** @type {LocalizedString} */ ("Access was restored, taking a seat again. Everything they had before is available without reconnecting.")
});